import * as PropTypes from "prop-types";

import { RS } from "../../../../data/strings/global";
import * as SC from "../../../../data/strings/PIStringConst";

import * as Theme from "../../../../app/Theme";

import * as gbtc from "../../../GB/GBTableConst";
import * as gbtu from "../../../GB/GBTableUtil";
import * as piasu from "../../NonComponents/PIAppStateUtil";
import * as pisc from "../../NonComponents/PIServerConst";
import * as pitu from "../../NonComponents/PITableUtil";

import { generateTypes } from "../../../../utilities";
import SuperTableShim from "../../../common/SuperTableShim";

import { combinePriorPops, contCurveCombinedPops } from "../../NonComponents/PIPriorPopUtil";

const firstRow = 0;
const fileNameCol = 0;
const totalCol = 1;
const numNonPriorPopCols = totalCol + 1;
const priorPopStartCol = 2;

const PITargDisagDistrictPriorPopsAggResTable = (props) => {
  const modVarObjList = props.modVarObjList;

  const isPSEMode = piasu.isPSEMode(modVarObjList);

  let priorPops = piasu.getModVarValue(modVarObjList, pisc.priorPopsMVTag);

  const prepMVs = [
    "PI_TargetsByDistrictPrEP_NEWAggregate",
    "PI_TargetsByDistrictPrEP_CTAggregate",
    "PI_TargetsByDistrictPrEPRecipientsAggregate",
  ];
  const PrEPStatus = piasu.getModVarValue(modVarObjList, pisc.selectedPrEPStatusMVTag);
  const prepIdx = pisc.PrEP_Status_Options.indexOf(PrEPStatus);
  if (prepIdx === -1) throw new Error(`Unhandled PrEPStatus: ${PrEPStatus}`);

  const prepMVTag = prepMVs[prepIdx];

  let prepTargetsBy = piasu.getModVarValue(modVarObjList, prepMVTag, true);

  const selectedMethodMstID = piasu.getModVarValue(modVarObjList, pisc.selectedMethodMVTag);
  const methodObjList = piasu.getModVarValue(modVarObjList, pisc.methodsMVTag);
  const aggFilenames = piasu.getModVarValue(modVarObjList, pisc.aggFileNamesMVTag, true);

  const selectedMethodCurrID = piasu.getMethodCurrID(methodObjList, selectedMethodMstID);

  if (isPSEMode) {
    const combined = combinePriorPops(modVarObjList, contCurveCombinedPops, [], [prepMVTag]);
    priorPops = combined["PI_PriorityPop"];
    prepTargetsBy = combined[prepMVTag];
  }

  const numFiles = prepTargetsBy.length;
  const numRows = numFiles + 1;

  let packTable = gbtu.getNewPackTable();

  const numPriorPops = piasu.getTotalNumPriorPops(priorPops);
  const numCols = numPriorPops + numNonPriorPopCols;

  packTable = gbtu.resizePackTable(packTable, numRows, numCols);

  /* Set column headings */
  gbtu.setValue(packTable, 0, 0, RS(SC.GB_stFile));
  gbtu.setValue(packTable, firstRow, totalCol, RS(SC.GB_stTotal));

  let c = priorPopStartCol;
  for (let pp = 1; pp <= numPriorPops; pp++, c++) {
    const priorPopName = piasu.getPriorPopName(priorPops, pp);
    gbtu.setValue(packTable, firstRow, c, priorPopName);
  }

  for (let f = 1; f <= numFiles; f++) {
    gbtu.setValue(packTable, f, 0, aggFilenames[f - 1]);

    let c = priorPopStartCol;

    let total = 0;

    for (let pp = 1; pp <= numPriorPops; pp++, c++) {
      const prep_val = prepTargetsBy[f - 1][selectedMethodCurrID - 1][pp - 1];
      gbtu.setValue(packTable, f, c, prep_val);
      total += prep_val;
    }

    gbtu.setValue(packTable, f, totalCol, total);
  }

  gbtu.lockPackTable(packTable, true, false);
  gbtu.alignNumericCellsRight(packTable);
  gbtu.setRowAlignment(packTable, firstRow, gbtc.hAlign.center);
  gbtu.setRDecs(packTable, 0);
  gbtu.setColWidths(packTable, Theme.dataColWidthMed);
  // Using *2 to align this with the PITargDisagDistrictPriorPopsResTable cols
  gbtu.setColWidth(packTable, fileNameCol, Theme.itemNameColWidth * 2);
  gbtu.setRowHeight(packTable, firstRow, 50);

  return (
    <SuperTableShim
      font={Theme.tableFont}
      headerBackgroundColor={Theme.PI_PrimaryColor}
      oddRowBackgroundColor={Theme.PI_BandColor}
      packTable={packTable}
      types={generateTypes(packTable)}
      onPackTableChanged={() => {}}
      removedMenuNames={pitu.tableHideMenuItems}
      style={{
        tableFont: Theme.tableFont,
        marginTop: Theme.ctrlSpacing,
        padding: 0,
      }}
    />
  );
};

PITargDisagDistrictPriorPopsAggResTable.propTypes = {
  modVarObjList: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default PITargDisagDistrictPriorPopsAggResTable;
